import { useEffect, useState } from 'react';

const EnvChecker = ({ children }: { children: React.ReactNode }) => {
  const [envError, setEnvError] = useState<string | null>(null);

  useEffect(() => {
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
    const supabaseKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

    console.log('🔍 Verificando variáveis de ambiente...');
    console.log('VITE_SUPABASE_URL:', supabaseUrl ? '✅ Presente' : '❌ AUSENTE');
    console.log('VITE_SUPABASE_PUBLISHABLE_KEY:', supabaseKey ? '✅ Presente' : '❌ AUSENTE');

    const errors: string[] = [];
    
    if (!supabaseUrl || supabaseUrl === 'undefined' || supabaseUrl === '') {
      errors.push('VITE_SUPABASE_URL está ausente ou vazia');
    }
    
    if (!supabaseKey || supabaseKey === 'undefined' || supabaseKey === '') {
      errors.push('VITE_SUPABASE_PUBLISHABLE_KEY está ausente ou vazia');
    }

    if (errors.length > 0) {
      setEnvError(errors.join('\n'));
      console.error('❌ ERRO DE CONFIGURAÇÃO:', errors);
    } else {
      console.log('✅ Todas as variáveis de ambiente estão configuradas');
    }
  }, []);

  if (envError) {
    return (
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#1a1a2e',
        color: '#fff',
        padding: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'system-ui, sans-serif'
      }}>
        <div style={{
          maxWidth: '600px',
          padding: '32px',
          backgroundColor: '#f59e0b',
          borderRadius: '12px',
          textAlign: 'center'
        }}>
          <h1 style={{ color: '#1a1a2e', marginBottom: '16px', fontSize: '24px' }}>
            ⚠️ Erro de Configuração
          </h1>
          <p style={{ color: '#1a1a2e', marginBottom: '16px' }}>
            As variáveis de ambiente não estão configuradas corretamente:
          </p>
          <pre style={{
            backgroundColor: '#000',
            color: '#f87171',
            padding: '16px',
            borderRadius: '8px',
            textAlign: 'left',
            whiteSpace: 'pre-wrap',
            fontSize: '14px'
          }}>
            {envError}
          </pre>
          <p style={{ color: '#1a1a2e', marginTop: '16px', fontSize: '14px' }}>
            Verifique se o deploy foi feito corretamente.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default EnvChecker;
